import { render, staticRenderFns } from "./channel-nextProgram.vue?vue&type=template&id=07b515dc&scoped=true&lang=pug"
import script from "./channel-nextProgram.vue?vue&type=script&lang=js"
export * from "./channel-nextProgram.vue?vue&type=script&lang=js"
import style0 from "./channel-nextProgram.vue?vue&type=style&index=0&id=07b515dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b515dc",
  null
  
)

export default component.exports